import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import LoginRequest from '../../../RunPay/Admin/IServices/Models/Accounts/LoginRequest';
import ChangePasswordRequest from '../../../RunPay/Admin/IServices/Models/Accounts/ChangePasswordRequest';
import WsResponseModel from '../../../SchemaBuilderServer/Models/WsResponseModel';
import UserResponse from '../../../RunPay/Admin/IServices/Models/Accounts/UserResponse';
import BaseResponse from '../../../Common/ResponseModels/BaseResponse';

export default class AccountService {
	webApiService: WebApiService;
	LoginEvent = new Events<WsResponseModel<UserResponse>>();
	GetUserEvent = new Events<WsResponseModel<UserResponse>>();
	ChangePasswordEvent = new Events<WsResponseModel<BaseResponse>>();
	LogoutEvent = new Events<WsResponseModel<BaseResponse>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('AccountService', 'Login', (res: WsResponseModel<UserResponse>) => {
			self.LoginEvent.trigger(res);
		});
		webApiService.on('AccountService', 'GetUser', (res: WsResponseModel<UserResponse>) => {
			self.GetUserEvent.trigger(res);
		});
		webApiService.on('AccountService', 'ChangePassword', (res: WsResponseModel<BaseResponse>) => {
			self.ChangePasswordEvent.trigger(res);
		});
		webApiService.on('AccountService', 'Logout', (res: WsResponseModel<BaseResponse>) => {
			self.LogoutEvent.trigger(res);
		});
	}
	Login(request: LoginRequest = null) { 	
        this.webApiService.send('AccountService', 'Login' , request);
    }
	GetUser() { 	
        this.webApiService.send('AccountService', 'GetUser' );
    }
	ChangePassword(request: ChangePasswordRequest = null) { 	
        this.webApiService.send('AccountService', 'ChangePassword' , request);
    }
	Logout() { 	
        this.webApiService.send('AccountService', 'Logout' );
    }
	 // async methods
	async loginAsync(request: LoginRequest = null): Promise<UserResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.Login.bind(this), this.LoginEvent)(request);
	}
	async getUserAsync(): Promise<UserResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetUser.bind(this), this.GetUserEvent)();
	}
	async changePasswordAsync(request: ChangePasswordRequest = null): Promise<BaseResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.ChangePassword.bind(this), this.ChangePasswordEvent)(request);
	}
	async logoutAsync(): Promise<BaseResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.Logout.bind(this), this.LogoutEvent)();
	}
}


// WEBPACK FOOTER //
// ./scripts/dataSource/api/RunPay/Admin/Services/AccountService.ts